/**
 * ClientDetailPage — Contenu principal de la fiche client (colonne droite)
 *
 * Affiche les onglets d'analyse astrologique du chart sélectionné.
 * La sidebar gauche est gérée par ClientLayout.
 */

import { Link, useParams } from 'react-router-dom';
import { colors } from '../styles/tokens.js';
import { useClient } from '../contexts/ClientContext.js';
import { AnalysisTabs } from '../components/analysis/AnalysisTabs.js';

export function ClientDetailPage() {
  const { id } = useParams<{ id: string }>();
  const {
    client, selectedChartId, analysis, analysisLoading, setAnalysis,
  } = useClient();

  if (!client) return null;

  const selectedChart = client.charts.find((c) => c.id === selectedChartId);

  if (client.charts.length === 0) {
    return (
      <div style={{
        background: '#fff', borderRadius: 8, padding: '3rem',
        textAlign: 'center', boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
      }}>
        <i className="bi bi-stars" style={{ fontSize: '3rem', color: colors.accent, display: 'block', marginBottom: '1rem' }} />
        <h3 style={{ marginBottom: '0.5rem' }}>Aucune donnee astrologique</h3>
        <p style={{ color: colors.textMid, marginBottom: '1.5rem' }}>
          Importez les donnees CSV depuis Olympia pour analyser le theme natal.
        </p>
        <Link
          to={`/clients/${id}/import`}
          style={{
            padding: '10px 20px', borderRadius: 6, border: 'none',
            background: colors.accent, color: colors.text, fontSize: 14,
            fontWeight: 600, textDecoration: 'none', display: 'inline-block',
          }}
        >
          <i className="bi bi-file-earmark-arrow-up" style={{ marginRight: 6 }} />
          Importer CSV Olympia
        </Link>
      </div>
    );
  }

  if (analysisLoading) {
    return (
      <div style={{ fontSize: 14, color: colors.textMuted, padding: '2rem', textAlign: 'center' }}>
        Calcul de l'analyse...
      </div>
    );
  }

  if (!analysis) {
    return (
      <div style={{ fontSize: 14, color: colors.textMuted, padding: '2rem', textAlign: 'center' }}>
        Selectionnez un theme pour afficher l'analyse.
      </div>
    );
  }

  return (
    <AnalysisTabs
      analysis={analysis}
      importDate={selectedChart?.createdAt}
      clientId={Number(id)}
      chartId={selectedChartId!}
      onAnalysisUpdate={setAnalysis}
    />
  );
}
